import React from "react";
import { MsalContext } from "@azure/msal-react";

import "../css/Site.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { apiConfig } from "../authConfig";
require('bootstrap/dist/js/bootstrap.bundle')



export class IndustryReports extends React.Component {
    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            reportTypeName: "",
            reportTypeValue: "",
            selectPrimaries: true,
            selectedTags: [],
            selectDropDown: "1",
            isLoaded: false,
            classifications: [],
            error: null
            };
      }

    componentDidMount() {
        const msalInstance = this.context.instance;
        const msalAccounts = this.context.accounts;

        const account = msalAccounts[0];

            if (account) {
                msalInstance.acquireTokenSilent({
                    scopes: apiConfig.scopes,
                    account: account
                }).then((tokenResponse) => {
                    if(tokenResponse) {
                        const accessToken = tokenResponse.accessToken;        
                        const headers = new Headers();
                        const bearer = `Bearer ${accessToken}`;
                        headers.append("Authorization", bearer);
                        headers.append("Content-Type", "application/json");

                        const options = {
                            method: "GET",
                            headers: headers
                        };

                        fetch(apiConfig.apiUri + "/ir/GetTagOptions", options)
                        .then(res => res.json())
                        .then(
                          (result) => {
                            this.setState({
                                isLoaded: true,
                                classifications: result
                            });
                          },
                          (error) => {
                              console.log(error);
                            this.setState({
                                isLoaded: true,
                                error: error
                              });
                        }
                        )            
                    }
                });
            }
    
    }
    
    componentWillUnmount() {
    }

    selectAll = e => {
        let alltags =[];

        this.state.classifications?.map((item) => {
            alltags.push(item.tagId); 
            item.children?.map((child) => (
                alltags.push(child.tagId)
            ))
            return 0;
        });

        this.setState({
            selectedTags: alltags
        })

        e.preventDefault();

    }

    clearAll = e => {
        this.setState({
            selectedTags: []
        });

        e.preventDefault();
    }

    onChangeType = e => {
        this.setState({
            reportTypeName: e.target.name,
            reportTypeValue: e.target.value,            
        })
    }

    onChangePrimaries = (e) => {
        this.setState({
            selectPrimaries: !this.state.selectPrimaries,
        })
    }

    onChangeDropDown = e => {
        this.setState({
            selectDropDown: e.target.value,
        })
    }

    onChangeCheckBox = e => {
        if(e.target.checked) {
            this.setState({
                selectedTags: [ ...this.state.selectedTags, e.target.value]
            })
        }
        else{
            this.setState({
                selectedTags: this.state.selectedTags.filter(item => item !== e.target.value)
            })
        }
    }

    handleSubmit = e => {
        console.log("run here!");
        e.preventDefault()
        var report = this.state.reportTypeValue;
        var selectPrimaries = this.state.selectPrimaries;
        var divisionId = this.state.selectDropDown;
        var selectedTags = this.state.selectedTags;

        const msalInstance = this.context.instance;
        const msalAccounts = this.context.accounts;

        const account = msalAccounts[0];

            if (account) {
                msalInstance.acquireTokenSilent({
                    scopes: apiConfig.scopes,
                    account: account
                }).then((tokenResponse) => {
                    if(tokenResponse) {
                        const accessToken = tokenResponse.accessToken;        
                        const headers = new Headers();
                        const bearer = `Bearer ${accessToken}`;
                        headers.append("Authorization", bearer);
                        headers.append("Content-Type", "application/json");

                        fetch(apiConfig.apiUri + "/ir/GenerateReport",
                        {
                            method: "POST",
                            cache: "no-cache",
                            headers: headers,
                            body: JSON.stringify({
                                report: report,
                                selectPrimaries: selectPrimaries,
                                divisionId: divisionId,
                                selectedTags: selectedTags
                            })
                        })
                        .then(response=> {
                            const filename = response.headers
                            .get("content-disposition")
                            .split(';')[1]
                            .split('=')[1];
                            response.blob()
                            .then(blob => {
                            let url = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            a.href = url;
                            a.download = filename;
                            a.click();
                            });
                        });                    
                    }
                });
            }
    
        // fetch("https://localhost:44380/api/ir/GenerateReport",
        //     {
        //         method: "POST",
        //         cache: "no-cache",
        //         headers:{
        //             'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify({
        //             report: report,
        //             selectPrimaries: selectPrimaries,
        //             divisionId: divisionId,
        //             selectedTags: selectedTags
        //         })
        //     })
        //     .then(response=> {
        //         const filename = response.headers
        //         .get("content-disposition")
        //         .split(';')[1]
        //         .split('=')[1];
        //         response.blob()
        //         .then(blob => {
        //         let url = window.URL.createObjectURL(blob);
        //         let a = document.createElement('a');
        //         a.href = url;
        //         a.download = filename;
        //         a.click();
        //         });
        //     });
    }

     render() {
        if (!this.state.isLoaded) {
            return <div>Loading...</div>;
        }
        else { 
            return (
                <form onSubmit={this.handleSubmit} id="form1">                                
                    <div className="container">            
                        <div className="header">
                            <h3 className="text-muted">NAM Industry Classification Reports</h3>
                        </div>
                        <br />
                        <br />
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row well">
                                    <div className="col-lg-3">
                                        <span>Select report:</span>
                                    </div>

                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup1" checked={this.state.reportTypeValue === "MW" ? true: false} onChange={this.onChangeType} value="MW" />
                                        <span>Member Word Report</span>
                                    </div>
                    
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup2" checked={this.state.reportTypeValue === "P" ? true: false} onChange={this.onChangeType} value="P" />
                                        <span>Prospect Excel Report</span>
                                    </div>
                            
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup3" checked={this.state.reportTypeValue === "ME" ? true: false} onChange={this.onChangeType} value="ME" />
                                        <span>Members Excel Report</span>
                                    </div>
                            
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup4" checked="unchecked" onChange={this.onChangeType} value="" style={{display: "none"}} />
                                        <span>.</span>
                                    </div>
                            
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup5" checked="unchecked" onChange={this.onChangeType} value="" style={{display: "none"}} />
                                        <span>.</span>
                                    </div>
                            
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup6" checked={this.state.reportTypeValue === "PF" ? true: false} onChange={this.onChangeType} value="PF" />
                                        <span>Prospect Excel Report - Formatted</span>
                                    </div>
                            
                                    <div className="col-lg-3">
                                        <input type="radio" name="reportGroup7" checked={this.state.reportTypeValue === "MEF" ? true: false} onChange={this.onChangeType} value="MEF" />
                                        <span>Members Excel Report - Formatted</span>
                                    </div>

                                </div>
                                <br />
                                <div className="row panel panel-default">
                                    <div className="panel-heading">
                                        <div>
                                            Select Classifications &nbsp;&nbsp;
                                            {this.state.selectedTags.length === 0 && <span style={{color: "red"}}>(You must select at least one Industry Sector Classification to run the reports.)</span>}
                                        </div>
                                        <br />

                                        <div>
                                            <button onClick={this.selectAll}>Select All</button>&nbsp;&nbsp;
                                            <button onClick={this.clearAll}>Clear All</button>
                                        </div>
                                        <div>
                                            <input type="checkbox" checked={this.state.selectPrimaries} onChange={this.onChangePrimaries} />&nbsp;
                                            <span>Select only Companies with selected tags as primary industries?</span>
                                            <br />
                                            <select value={this.state.selectDropDown} onChange={this.onChangeDropDown}>
                                                <option value="1">Field</option>
                                                <option value="5">National</option>
                                                <option value="0">Both</option>
                                            </select>&nbsp;
                                            <span>Select 'Field', 'National', or 'Both' to filter results from Field and National company records.</span>
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="panelBody">
                                            {this.state.classifications?.map((item) => {
                                                return(
                                                    <div key={item.tagId} className="row">
                                                        <div className="col-md-12">
                                                            <input type="checkbox" checked={this.state.selectedTags.includes(item.tagId)} onChange={this.onChangeCheckBox} value={item.tagId} />&nbsp;
                                                            <span>{item.tagName}</span>
                                                        </div>
                                                        <div className="row">
                                                            {item.children?.map((child) => {
                                                                return (
                                                                    <div key={child.tagId} className="col-md-offset-1 col-md-11">
                                                                        <input type="checkbox" checked={this.state.selectedTags.includes(child.tagId)} onChange={this.onChangeCheckBox} value={child.tagId} />&nbsp;
                                                                        <span>{child.tagName}</span>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )}
                                        </div>
                                    </div>
                                </div>
                
                                <br />
                                <div className="row">
                                    <div className="col-lg-2">&nbsp;</div>
                                    <div className="col-lg-4">
                                        {this.state.selectedTags.length === 0 && 
                                        <div>
                                            The button to "Get Report" will become visible here after you choose one of the industries above.
                                        </div>
                                        }
                                        {this.state.selectedTags.length > 0 &&
                                        <div>
                                            <button type="submit">Get Report</button>
                                        </div>
                                        }
                                    </div>
                                    <div className="col-lg-6">&nbsp;</div>
                                </div>
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                        </div>
                    </div>                    
                </form>                
            )
        }
    }
}